<template>
  <div
    class="day-badge"
    :class="{ 'day-badge--novy': isNovy }"
    :style="{ opacity: badgeOpacity }"
  >
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "DayBadge",
  props: {
    date: {
      type: [String, Date],
      required: true,
    },
    today: {
      type: [String, Date],
      default: () => new Date(),
    },
  },

  computed: {
    diffDays() {
      const toUtcDay = (d) => {
        const x = d instanceof Date ? d : new Date(d);
        if (Number.isNaN(x.getTime())) return null;
        return Date.UTC(x.getFullYear(), x.getMonth(), x.getDate());
      };

      const start = toUtcDay(this.date);
      const end = toUtcDay(this.today);
      if (start === null || end === null) return 0;

      const ms = end - start;
      const oneDay = 24 * 60 * 60 * 1000;

      return Math.max(0, Math.round(ms / oneDay));
    },

    isNovy() {
      return this.diffDays === 0;
    },

    dayNumber() {
      return this.diffDays + 1;
    },

    label() {
      return this.isNovy ? "NOVÝ" : `deň ${this.dayNumber}`;
    },

    badgeOpacity() {
      if (this.isNovy) return 1;

      if (this.dayNumber === 2) return 1;

      if (this.dayNumber === 3) return 0.8;

      if (this.dayNumber === 4) return 0.6;

      return 0.4;
    },
  },
};
</script>

<style scoped>
.day-badge {
  min-width: 70px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 18px;
  border-radius: 999px;
  background: #3478f6;
  color: white;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: lowercase;
  transition: opacity 0.2s;
  margin-right: 20px;
}

@media screen and (max-width: 767px) {
  .day-badge{
    display: none;
  }
}

.day-badge--novy {
  background: transparent !important;
  color: #3478f6 !important;
  padding: 0;
}
</style>
